import * as XLSX from 'xlsx';
import Worksheet from './worksheet';

export default class Workbook {
  /** @param {XLSX.WorkBook} wb */
  constructor(wb) {
    this.wb = wb;
    this.createWorkSheets();
  }

  createWorkSheets() {
    this.worksheets = {};
    this.getSheetNames().forEach((sheetName) => {
      const ws = this.wb.Sheets[sheetName];
      const sheetAsJson = XLSX.utils.sheet_to_json(ws);
      this.worksheets[sheetName] = new Worksheet(ws, sheetAsJson);
    });
  }

  /**
   * @param {string} sheetName
   * @returns {Worksheet}
   */
  getWorksheet(sheetName = 'Sheet1') {
    return this.worksheets[sheetName];
  }

  /** @returns {Array<string>} */
  getSheetNames() {
    return this.wb.SheetNames;
  }
}
